const init = () => {
    globalClicks();
    backToTop();
    pdpReviewsScrollFix();
    // industriesServedDropdown();
};

const globalClicks = () => {
    document.addEventListener('click', function (e) {
        const target = e.target;
        mobileFooter(target);
        readMore(target);
        collapsibleTabs(target, e); // Open one collapsible tab at a time (.one-rule)
    }, false);
};
const backToTop = () => {
    const goTopBtn = document.getElementById('BackToTop');
    if (goTopBtn) {
        window.addEventListener('scroll', () => {
            const scrolled = window.pageYOffset;
            const coords = 200;
            if (scrolled > coords) {
                goTopBtn.classList.add('shown');
            }
            if (scrolled < coords) {
                goTopBtn.classList.remove('shown');
            }
        });
        goTopBtn.addEventListener('click', (e) => {
            if (window.pageYOffset > 0) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    }
};
const pdpReviewsScrollFix = () => {
    setTimeout(() => {
        if (document.querySelector('.product .product__info-wrapper .jdgm-preview-badge--with-link') && document.getElementById('judgeme_product_reviews')) {
            document.querySelectorAll('.jdgm-preview-badge--with-link').forEach(element => {
                const newElement = element.cloneNode(true);
                element.parentNode.replaceChild(newElement, element);
              });
            const elements = document.querySelectorAll('.jdgm-preview-badge--with-link');
            elements.forEach(element => {
                element.addEventListener('click', function(e) {
                    e.preventDefault();
                    const reviewsElement = document.getElementById('judgeme_product_reviews');
                    const header = document.getElementsByClassName('header-wrapper')[0];
                    if (reviewsElement && header) {
                        const headerHeight = header.offsetHeight;
                        const elementPosition = reviewsElement.getBoundingClientRect().top + window.pageYOffset;
                        const offsetPosition = elementPosition - headerHeight;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }
      }, 1000);
};
const mobileFooter = (target) => {
    if (window.screen.width < 800) {
        if (target.classList.contains('footer-block__heading')) {
            const dropdownEl = target.closest('.footer-block-content');
            const isOpen = dropdownEl.classList.contains('open');
            if (isOpen) {
                dropdownEl.classList.remove('open');
            }
            else {
                dropdownEl.classList.add('open');
            }
        }
    }
};
const readMore = (target) => {
    if (target.classList.contains('read-more')) {
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};
const updateDesktopLinks = (id) => {
    const desktopToggles = document.querySelectorAll('.collapsible-desktop-toggle');
    if (desktopToggles.length) {
        desktopToggles.forEach(toggleEl => {
            if (toggleEl.classList.contains('is-open')) {
                toggleEl.classList.remove('is-open');
            }
        });
        const openedLink = document.querySelector(`[data-selector="${id}"]`);
        openedLink.classList.add('is-open');
    }
};
const collapsibleTabs = (target, e) => {
    if (window.screen.width >= 990) {
        if (target.classList.contains('collapsible-mobile-title') || target.tagName == 'SUMMARY') {
            const collapsibleContainer = target.closest('.collapsible-content-container');
            if (collapsibleContainer && collapsibleContainer.classList.contains('one-rule')) {
                e.preventDefault();
                const details = target.closest('details');
                const summary = details.querySelector('summary');

                collapsibleContainer.querySelectorAll('details').forEach((element) => {
                    if (element != details) {
                        element.removeAttribute("open");
                    }
                });
                collapsibleContainer.querySelectorAll('summary').forEach((element) => {
                    if (element.classList.contains('is-open') && element != summary) {
                        element.classList.remove('is-open');
                    }
                });
                updateDesktopLinks(summary.id);
                summary.classList.add('is-open');
                details.setAttribute('open', 'true');
            }
        }
        if (target.classList.contains('collapsible-desktop-title') || target.classList.contains('collapsible-desktop-toggle')) {
            e.preventDefault();
            let targetEl = target;
            if (target.classList.contains('collapsible-desktop-title')) {
                targetEl = targetEl.parentElement;
            }
            const selectorId = targetEl.dataset.selector;
            const blogTag = document.getElementById(selectorId);
            blogTag.click();
        }
    }
};
// const industriesServedDropdown = () => {
//     if (window.innerWidth >= 990) {
//         const industriesDetails = document.getElementById('Details-HeaderMenu-industries-served');
//         const industriesMenu = document.getElementById('HeaderMenu-industries-served');
//         const menuContainer = document.querySelector('.header-middle-menu-container');
        
//         if (industriesDetails && industriesMenu && menuContainer) {
//             industriesMenu.addEventListener('mouseenter', function(e) {
//                 industriesDetails.setAttribute('open', '');
//                 document.body.classList.add('industries-dropdown-active');
//             });
            
//             industriesDetails.addEventListener('mouseleave', function(e) {
//                 setTimeout(() => {
//                     industriesDetails.removeAttribute('open');
//                     document.body.classList.remove('industries-dropdown-active');
//                 }, 100);
//             });
            
//             document.addEventListener('click', function(e) {
//                 if (!industriesDetails.contains(e.target) && 
//                     document.body.classList.contains('industries-dropdown-active')) {
//                     industriesDetails.removeAttribute('open');
//                     document.body.classList.remove('industries-dropdown-active');
//                 }
//             });
//         }
//     }
    
//     window.addEventListener('resize', () => {
//         if (window.innerWidth < 990) {
//             const industriesDetails = document.getElementById('Details-HeaderMenu-industries-served');
//             if (industriesDetails) {
//                 industriesDetails.removeAttribute('open');
//                 document.body.classList.remove('industries-dropdown-active');
//             }
//         }
//     });
// };
(function () {
    init();
})();